<template>
  <el-container class="backgroundContainer">
    <el-header class="navbar" style="height: auto">
      <UserInfo v-if="isLoggedIn" />
    </el-header>
    <el-container>
      <BhpAside />
      <el-main class="marginMain">
        <router-view></router-view>
        <SupportFooter />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import SetInterval from "set-interval";
import axios from "axios";
import { mapGetters } from "vuex";
import UserInfo from "@/components/UserInfo.vue";
import SupportFooter from "@/components/SupportFooter.vue";
import BhpAside from "@/components/bhpAside.vue";

export default {
  name: "app",
  components: {
    UserInfo,
    SupportFooter,
    BhpAside,
  },
  computed: {
    ...mapGetters({
      isLoggedIn: "isLoggedIn",
    }),
  },
  async mounted() {
    if (this.$route.path !== "/") {
      await this.$store.dispatch("checkIsLoggedIn").then((logStatus) => {
        if (!logStatus) {
          this.signOut();
        }
      });
      await this.$store.dispatch("setRole");
    }
  },
  created() {
    this.execute1();
  },
  methods: {
    async execute1() {
      while (true) {
        await new Promise((resolve) => setTimeout(resolve, 30000));
        if (this.isLoggedIn === true) {
          this.statusSession();
        }
      }
    },
    async statusSession() {
      const config = {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      };
      var response = await axios.get(
        `/usuarios/sessionActiva/${this.$store.getters.user.id_sesion}`,
        config
      );
      if (response.data.active === 0) {
        this.signOut();
        this.$alert(
          "Se ha iniciado sesión con su usuario en otra computadora",
          "Información",
          {
            confirmButtonText: "Aceptar",
            callback: (action) => {
              if (window.location.hostname === "bhp.lifeon.cl") {
                window.location = "https://bhp.lifeon.cl/es";
              } else {
                window.location = "https://release.bhp.lifeon.cl/es";
              }
            },
          }
        );
      }
    },
    async signOut() {
      // reset datos de otros roles
      await this.$store.dispatch("resetEmpresasFaena");
      await this.$store.dispatch("resetAreas");
      await this.$store.dispatch("resetContract");
      await this.$store.dispatch("resetUserContractByRole");

      await this.$store.dispatch("logout", this.$store.getters.user.id_sesion);

      if (window.location.hostname === "bhp.lifeon.cl") {
        window.location = "https://bhp.lifeon.cl/es";
      } else {
        window.location = "https://release.bhp.lifeon.cl/es";
      }
    },
  },
};
</script>

<style>
.el-alert__content {
  width: 100%;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item {
  color: black !important;
  font-weight: bold !important;
}

.el-tabs--border-card > .el-tabs__header .el-tabs__item.is-active {
  color: #f67b2f !important;
}

.el-loading-mask {
  position: absolute;
  z-index: 3;
}

.navbar {
  position: sticky;
  top: 0;
  z-index: 90;
}

.cellClassTablaPlomaInventarioTarea {
  border-width: 2px !important;
  border-color: white !important;
  padding: 0 !important;
  color: black !important;
}
.rowClassTablaPlomaInventarioTarea {
  background-color: #efefef !important;
  border: white !important;
  padding: 0px !important;
}
.rowDashboard {
  border-color: black !important;
  padding: 0px !important;
}
.header {
  background-color: #086972 !important;
  color: white !important;
  padding: 0px !important;
}

.header-orange {
  background-color: #f37121 !important;
  color: white !important;
  padding: 0px !important;
}

.header-blue {
  background-color: gray !important;
  color: white !important;
  padding: 0px !important;
}

.header-blue-light {
  background-color: #727997 !important;
  color: white !important;
  padding: 0px !important;
}

.header-blue-light-2 {
  background-color: #4f844f !important;
  color: white !important;
  padding: 0px !important;
}

.el-table th,
.el-table td {
  padding: 0px !important;
}

.header-cell-risk {
  background-color: rgb(230, 84, 0) !important;
  color: white !important;
  padding: 0px !important;
  border-width: 2px !important;
}

.header-cell-class-table-gray {
  background-color: #242424 !important;
  color: white !important;
  padding: 0px !important;
  border-width: 2px !important;
}
.header-cell-class-table-gray-2 {
  background-color: #242424 !important;
  color: white !important;
  padding: 0px !important;
  border-width: 2px !important;
}
.cellClassTablaPloma {
  border-width: 1px !important;
  border-color: white white grey white !important;
  padding: 2px !important;
}
.sinTipo {
  background-color: gray !important;
  color: white !important;
}
.rowClassTablaPloma {
  background-color: white !important;
  padding: 0px !important;
}

.paddingBody {
  padding: 20px;
}
.fullHeight {
  min-height: 100vh !important;
}
.el-tabs--border-card {
  border: none;
}
.el-tabs--border-card > .el-tabs__header {
  background-color: #e6e6e6;
}
.el-main {
  padding: 0 !important;
}
.el-aside {
  overflow: hidden;
}
.el-header {
  padding: 0 !important;
}
html,
body {
  margin: 0;
  padding: 0;
}

#app {
  font-family: Arial, sans-serif !important;
}

textarea,
.el-popover,
.el-message,
.el-select-dropdown,
.el-message-box,
.el-autocomplete-suggestion,
.el-date-picker,
.el-notification,
.el-dialog,
.notification {
  font-family: Arial, sans-serif;
}

.el-popover {
  color: gray;
  text-align: left;
}

.el-popover__title {
  font-weight: bold;
}

.el-button {
  white-space: normal;
}

.el-menu--horizontal {
  border-bottom: transparent !important;
}

.el-form--label-top .el-form-item__label {
  padding: 0 !important;
}

.el-dialog__body {
  padding-top: 0;
}

.full-width {
  width: 100% !important;
}

h1 {
  margin-top: 5px;
  margin-bottom: 0;
  color: rgb(131, 138, 142);
}

h1 small {
  display: block;
  font-size: 0.8em;
  color: rgba(131, 138, 142, 0.5);
  margin-bottom: 10px;
}

h2 {
  color: rgb(246, 123, 47);
  margin-top: 5px;
  margin-bottom: 40px;
}

h4 {
  color: rgb(131, 138, 142);
  font-weight: normal;
}

.container {
  width: 85%;
  margin: 0 auto;
  padding: 20px;
}

.el-table .row-danger {
  background-color: rgba(255, 73, 73, 0.1);
}

.el-table .row-warning {
  background-color: rgba(247, 186, 41, 0.2);
}

.customRiskBox {
  text-transform: uppercase;
  font-weight: bold;
  border: 1px solid black;
  border-radius: 7px;
  max-width: 100%;
  font-size: 12px;
  text-align: center;
  margin: 0 auto;
  width: 100px;
  padding-top: 20px;
  padding-bottom: 20px;
  padding-left: 10px;
  padding-right: 10px;
  min-height: 110px;
  word-break: break-word;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 40px;
}
.customRiskBox.material {
  background-color: rgb(230, 84, 0);
  color: white;
}
.customRiskBox.noMaterial {
  background-color: rgb(250, 182, 54);
  color: black;
}
.customRiskBox.custom {
  background-color: rgb(71, 100, 117);
  color: white;
}
.customRiskBox.material.medioambiental {
  background-color: rgb(1, 137, 130);
  color: white;
}
.customRiskBox.medioambiental {
  background-color: rgb(179, 222, 104);
  color: black;
}
.customRiskBox .sign {
  font-size: 60px;
  margin-bottom: 20px;
}
.customRiskBox .content {
  display: inline-block;
  vertical-align: middle;
  line-height: normal;
}
.big-submit {
  width: 300px;
  font-weight: bold;
}
.control-critico {
  color: red;
}
.cell {
  padding: 10px;
}
.help-box {
  display: inline;
  cursor: pointer;
}
.with-help-box {
  max-width: 93% !important;
  margin-right: 4px;
}

.download-box {
  margin-bottom: 70px;
}
.download-box a {
  text-decoration: none;
  text-align: center;
  float: left;
  width: 50%;
  color: rgb(246, 123, 47);
}
.download-box .icon {
  font-size: 30px;
  margin-bottom: 10px;
}
.download-box .mini-text {
  font-size: 11px;
}
.resp-container {
  position: relative;
  overflow: hidden;
  padding-top: 56.25%;
}
.resp-iframe {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border: 0;
}
.video-cont {
  max-width: 600px;
  text-align: center;
  margin: 0 auto;
}
.title-download {
  margin-top: 30px;
  text-align: center;
}
.el-icon-question {
  font-size: 20px;
}

.backgroundContainer {
  background-color: #e6e6e6;
}

/*ANCHOS*/
.w-100 {
  width: 100% !important;
}
.w-90 {
  width: 90% !important;
}
/*MARGENES*/
.mt-10 {
  margin-top: 10px;
}
.mt-15 {
  margin-top: 15px;
}
.mt-20 {
  margin-top: 20px;
}
.mr-10 {
  margin-right: 10px;
}
.mr-15 {
  margin-right: 15px;
}
.mr-20 {
  margin-right: 20px;
}
.ml-10 {
  margin-left: 10px;
}
.ml-15 {
  margin-left: 15px;
}
.ml-20 {
  margin-left: 20px;
}
/*POSICIONES*/
.right {
  float: right !important;
}
.left {
  float: left !important;
}
/*COLORES*/
.green {
  background-color: #6ac35c !important;
}
/* .green{ background-color: #6bc45b; } */
.red {
  background-color: #b84858 !important;
}
.yellow {
  background-color: #dac554 !important;
}
/* .yellow{ background-color: #e4d306; } */
.gray {
  background-color: #808080 !important;
}
/*ALINEACIÓN TEXTO*/
.text-left {
  text-align: left !important;
}
.text-center {
  text-align: center !important;
}
.text-right {
  text-align: right !important;
}
/*COLORES TEXTO*/
.text-white {
  color: #ffffff !important;
}
.text-bhp {
  color: #e65400 !important;
}
.text-muted {
  opacity: 0.5 !important;
}
/* TAGS */
.safety-tag {
  padding: 5px 10px;
  background: #808080;
  color: white;
}
.colorSeguridad {
  background-color: rgb(230, 84, 0) !important;
  color: white !important;
}
.colorCellDashboard {
  background-color: #086972 !important;
  color: white !important;
}
.colorCellDashboard2 {
  background-color: #f37121 !important;
  color: white !important;
}
.colorCellDashboard3 {
  background-color: gray !important;
  color: white !important;
}
.colorCellDashboard4 {
  background-color: #727997 !important;
  color: white !important;
}
.colorCellDashboard5 {
  background-color: #4f844f !important;
  color: white !important;
}
.colorSalud {
  background-color: rgb(0, 167, 245) !important;
  color: white !important;
}
.colorMedioambiente {
  background-color: rgb(40, 134, 98) !important;
  color: white !important;
}
.colorSaludySeguridad {
  background-color: gray !important;
  color: white !important;
}
.colorMedioambiental {
  background-color: rgb(40, 134, 98) !important;
  color: white !important;
}
.colorCustom {
  background-color: rgb(227, 0, 82) !important;
  color: white !important;
}
.colorWithoutRisk {
  background-color: #808080 !important;
  color: white !important;
}
.el-table__expand-icon {
  color: black !important;
}
.displayNone {
  display: none !important;
}
.titleCollapseTask {
  font-size: 14px;
}
.tagRiesgo {
  padding: 8px;
  color: white;
  font-size: 23px;
}
.inlineBlock {
  display: inline-block;
}
.iconSmall {
  height: 20px;
  width: 20px;
}
.iframeContainer {
  height: 100vh;
  overflow-y: hidden;
  overflow-x: hidden;
}
.iframeContainer iframe {
  width: 100%;
  height: 100%;
}
.iframeDialog .el-dialog__header {
  padding: 0;
}
.iframeDialog .el-dialog__body {
  padding: 0;
}
.el-dropdown-menu {
  font-family: Arial, sans-serif !important;
}
</style>
